import ExerciseGenerator from "./ExerciseGenerator";
import {getRandomIntegerWithinBitCount/*, getRandomIntegerWithRange*/} from "../Random";
import Exercise from "../Exercise";
import {decimalToBinary} from "../logic/Conversion";
import Modes from "../mode/Modes";
import ResultItem from "../ResultItem";
import NumberSystems from "../NumberSystems";

export default class Excess127ExerciseGenerator extends ExerciseGenerator{
    generate = (task) => {
        this.bitCount = 8;
        const result = [];
        if(!task) {
            //Two's complement range for 8 bit is -127:128
            const adjustedRange = Math.pow(2, this.bitCount)/2-1;
            while(!task || task < (adjustedRange*-1)) {
                task = getRandomIntegerWithinBitCount(this.bitCount, true);
            }
        }
        const bias = 127;

        if(this.mode.equals(Modes.DECIMAL_TO_BINARY_EXCESS_127_8_BIT)){
            result.push(
                new ResultItem(
                    decimalToBinary((task + bias), 8),
                    NumberSystems.BINARY
                )
            );
            return new Exercise([task], [String(task)], result);
        }else if(this.mode.equals(Modes.BINARY_TO_DECIMAL_EXCESS_127_8_BIT)){
            result.push(
                new ResultItem(
                    String(task),
                    NumberSystems.DECIMAL,
                    true,
                    true
                )
            );
            task = decimalToBinary((task + bias),8);
            return new Exercise([task], [String(task)], result);
        }
        else {
            console.error(this.mode);
            throw new Error("Unknown mode");
        }

    };

}